import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { ClosingReportService } from '../closing-report.service';

@Injectable()
export class ClosingReportGuard implements CanActivate {
  constructor(private closingReportService: ClosingReportService) {}

  public canActivate(): Observable<boolean> {
    return this.closingReportService.shouldShowClosingReports();
  }
}
